import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSign } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const AbsenceFinancialAccordion = ({ formData, updateField }) => {
  const { t } = useTranslation();

  return (
  <AccordionItem value="financial">
    <AccordionTrigger>
      <div className="flex items-center gap-2">
        <DollarSign className="h-5 w-5" />
        {t('absenceReasons.form.financialTitle')}
      </div>
    </AccordionTrigger>
    <AccordionContent className="space-y-4 pt-4">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="is_paid"
          checked={formData.is_paid}
          onCheckedChange={(checked) => {
            updateField('is_paid', checked);
            updateField('payment_rate', checked ? 100 : 0);
          }}
        />
        <Label htmlFor="is_paid" className="cursor-pointer">{t('absenceReasons.form.paidReason')}</Label>
      </div>

      {formData.is_paid && (
        <div className="space-y-2">
          <Label htmlFor="payment_rate">{t('absenceReasons.form.paymentRate')}</Label>
          <Input
            id="payment_rate"
            type="number"
            min="0"
            max="100"
            value={formData.payment_rate}
            onChange={(e) => updateField('payment_rate', parseFloat(e.target.value))}
          />
        </div>
      )}

      <div className="flex items-center space-x-2">
        <Checkbox
          id="deducts_from_salary"
          checked={formData.deducts_from_salary}
          onCheckedChange={(checked) => updateField('deducts_from_salary', checked)}
        />
        <Label htmlFor="deducts_from_salary" className="cursor-pointer">
          {t('absenceReasons.form.deductsFromSalary')}
        </Label>
      </div>
    </AccordionContent>
  </AccordionItem>
  );
};

export default AbsenceFinancialAccordion;
